import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useFetchUFCSchedule = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation(async (year) => {
    const token = await getAccessTokenSilently();
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/events/fetch-schedule/${year}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  });
};
